import ACTIONS from '../actionTypes/sideNavWiki';
import { SideNavCategoryConstants } from '../../constants';

const initialState = {
  openedCategoryIDs: {
    [SideNavCategoryConstants.WIKI]: [],
    [SideNavCategoryConstants.API_DOCS]: [],
  },
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_SIDENAV_OPENED_CATEGORIES: {
      return {
        ...state,
        openedCategoryIDs: {
          ...state.openedCategoryIDs,
          [action.payload.type]: [...action.payload.data],
        }
      };
    }
    case ACTIONS.CLEAR_SIDENAV_OPENED_CATEGORIES:
      return {
        ...state,
        openedCategoryIDs: {
          ...state.openedCategoryIDs,
          [action.payload]: [],
        }
      };
    default:
      return state;
  }
}
